// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UQjEM","question":"styles_question__x9ln1","description":"styles_description__2bEyy"};